import type { CountdownRenderProps } from 'react-countdown';
import Countdown from 'react-countdown';

import { ClockCountdown } from '@ui/uikit/components/icons/mono/ClockCountdown';

interface CampaignCounter {
  startDate?: string;
  endDate?: string;
}

export const CampaignCounter = ({ endDate, startDate }: CampaignCounter) => {
  if (!startDate || !endDate) {
    return null;
  }

  const currentDate = new Date();

  const parsedStartDate = new Date(startDate);
  const parsedEndDate = new Date(endDate);

  if (currentDate < parsedStartDate) {
    return null;
  }

  return (
    <div className="max-h-[56px] md-msq:max-h-[144px] w-full bg-base-bg rounded-lg md-msq:rounded-2xl story-prose-none flex items-center px-2 py-2 md-msq:px-6 md-msq:py-8 font-secondary mt-[14px] md-msq:mt-[40px]">
      <div className="border border-primary-200 rounded-lg flex justify-between items-center p-1 md-msq:p-6 w-full h-full gap-1">
        <div className="flex gap-1 md-msq:gap-3 text-sm leading-[24px] md-msq:text-[24px] md-msq:leading-[32px] font-semibold items-center">
          <ClockCountdown className="w-[20px] h-[20px] md-msq:w-[32px] md-msq:h-[32px]" />
          <Countdown
            date={parsedEndDate || currentDate}
            renderer={({ completed }: CountdownRenderProps) =>
              completed ? 'Contest Has Ended' : 'Contest Ends In'
            }
          />
        </div>
        <div className="text-base leading-[24px] md-msq:text-[28px] md-msq:leading-[32px] text-secondary-700 font-semibold truncate">
          <Countdown
            date={parsedEndDate || currentDate}
            renderer={({ days, hours, completed }: CountdownRenderProps) =>
              completed ? '' : `${days} Days, ${hours} Hours`
            }
          />
        </div>
      </div>
    </div>
  );
};
